import "./Footer.css";
import React, { useContext } from "react";
import ReactGA from "react-ga4";
import Logo from "../../assets/imgs/JG-Símbolo+Logotipo_Branco.svg";
import useTranslatedMenuItems from "./Btns-Content";
import { LanguageContext } from "../../context/LanguageContext";
import MenuBtn from "./MenuBtn";

const trackEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};

const WHATSAPP =
  "https://wa.me/5584994514529?text=" +
  encodeURIComponent("Olá Jacques, vi seu perfil e gostaria de discutir um projeto de IA.");

const copy = {
  en: {
    tagline: "Production AI for enterprise data.",
    contact: "Get in touch",
    navigationTitle: "Navigation",
    focusTitle: "Focus",
    focus: [
      "Multi-agent systems",
      "MCP & integrations",
      "Workflow automation",
      "High-volume data",
      "LLMOps",
    ],
    rights: "© 2026 Jacques Gomes.",
  },
  pt: {
    tagline: "IA de produção para dados empresariais.",
    contact: "Falar comigo",
    navigationTitle: "Navegação",
    focusTitle: "Foco",
    focus: [
      "Sistemas multi-agente",
      "MCP e integrações",
      "Automação de fluxos",
      "Dados em alto volume",
      "LLMOps",
    ],
    rights: "© 2026 Jacques Gomes.",
  },
};

const socials = [
  { href: "https://github.com/JacquesGomes/", label: "GitHub", icon: "uil uil-github-alt", name: "GitHub" },
  { href: "https://www.linkedin.com/in/jacques-gomes-627739240/", label: "LinkedIn", icon: "uil uil-linkedin-alt", name: "LinkedIn" },
  { href: "https://www.instagram.com/jacquesgomess/", label: "Instagram", icon: "uil uil-instagram", name: "Instagram" },
  { href: WHATSAPP, label: "WhatsApp", icon: "uil uil-whatsapp", name: "WhatsApp" },
  { href: "mailto:jacquesgomes66@gmail.com", label: "Email", icon: "uil uil-envelope", name: "Email" },
];

const Footer = ({ scrollToComponent }) => {
  const menuItems = useTranslatedMenuItems();
  const { language } = useContext(LanguageContext);
  const t = copy[language] || copy.en;

  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    trackEvent("Navigation", "click", "Footer - Scroll to Top");
  };

  const action = (address) => {
    if (address !== "Link") {
      scrollToComponent(address);
      trackEvent("Navigation", "click", `Footer Menu - ${address}`);
    } else {
      scrollUp();
    }
  };

  return (
    <footer className="site-footer">
      <div className="page-width site-footer-inner">
        <div className="site-footer-top">
          <div className="site-footer-brand">
            <img
              className="site-footer-logo"
              src={Logo}
              alt="Jacques Gomes"
              onClick={scrollUp}
            />
            <p className="site-footer-tagline">{t.tagline}</p>
            <a
              className="main-btn site-footer-cta"
              href={WHATSAPP}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackEvent("Contact", "click", "Footer Contact Button")}
            >
              {t.contact}
            </a>
          </div>

          <div className="site-footer-cols">
            <div>
              <p className="site-footer-kicker">{t.navigationTitle}</p>
              <nav className="site-footer-nav">
                {menuItems.map((item) => (
                  <MenuBtn key={item.label} action={action} data={item} scrollToComponent={scrollToComponent} />
                ))}
              </nav>
            </div>
            <div>
              <p className="site-footer-kicker">{t.focusTitle}</p>
              <ul className="site-footer-focus">
                {t.focus.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="site-footer-bottom">
          <p>{t.rights}</p>
          <div className="site-footer-socials">
            {socials.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noreferrer"
                aria-label={item.label}
                onClick={() => trackEvent("Social", "click", `Footer - ${item.name}`)}
              >
                <i className={item.icon}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
